
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/[seriesId]/viewer/[productId]/comment",
      function () {
        return require("private-next-pages/content/[seriesId]/viewer/[productId]/comment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/[seriesId]/viewer/[productId]/comment"])
      });
    }
  